import { type FC } from 'react';
import { DEFAULT_CHART_COLOR } from '../Chart';
import { Bar, BarChart, CartesianGrid, Cell, Legend, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';

export type BarChartData = Partial<Record<string, unknown>> & {
    color?: string;
};

interface BarChartComponentProps {
    chartData?: BarChartData[];
    chartKeys: string[];
    showLegend?: boolean;
}


const BarChartComponent: FC<BarChartComponentProps> = props => {
    const {
        chartData,
        chartKeys,
        showLegend = true,
    } = props;

    if (!chartData) {
        return null;
    }

    return (
        <div className="bar-chart-component">
            <ResponsiveContainer>
                <BarChart data={chartData}>
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="name" />
                    <YAxis />
                    <Tooltip />
                    {chartKeys.map((key, index) => {
                        const uniqueKey = `${key}-${index}`;
                        const defaultGroupBarColor = chartData[0].color || DEFAULT_CHART_COLOR;
                        const groupBarColor = (chartData[0][`${key}-color`] as string || defaultGroupBarColor);
                        return (
                            <Bar key={uniqueKey} dataKey={key} fill={groupBarColor} stroke={groupBarColor}>
                                {chartData.map(entry => {
                                    const barColor = (entry[`${key}-color`] as string || groupBarColor);
                                    return (
                                        <Cell key={`bar-${entry.name}`} fill={barColor} stroke={barColor} />
                                    );
                                })}
                            </Bar>
                        );
                    })}
                    {showLegend && (
                        <Legend
                            align="center"
                            verticalAlign="bottom"
                            wrapperStyle={{ paddingTop: '16px' }}
                        />
                    )}
                </BarChart>
            </ResponsiveContainer>
        </div>
    );
};

export default BarChartComponent;
